import { render } from "./BtnHelp.vue?vue&type=template&id=03f974f2&scoped=true"
import script from "./BtnHelp.vue?vue&type=script&lang=js"
export * from "./BtnHelp.vue?vue&type=script&lang=js"

import "./BtnHelp.vue?vue&type=style&index=0&id=03f974f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03f974f2"]])

export default __exports__